export const state = () => ({
  institutes: [],
  products: [],
})

export const actions = {
  async loadAll({ commit }) {
    const { data } = await this.$axios.get('institutes')

    commit('setInstitutes', data.data)
  },

  async loadAllProducts({ commit }) {
    const { data } = await this.$axios.get('institutes/products')

    commit('setProducts', data.data)
  },

  async loadMortgageProfiles() {
    const { data } = await this.$axios.get('institute-mortgage-profiles')

    return data.data
  },

  async saveMortgageProfiles(_, profiles) {
    const { data } = await this.$axios.put('institute-mortgage-profiles', {
      profiles,
    })

    return data.data
  },

  async save({ dispatch }, form) {
    if (form.id) {
      await dispatch('updateInstitute', form)
    } else {
      await dispatch('createInstitute', form)
    }

    await dispatch('loadAll')
  },

  async createInstitute({ dispatch }, form) {
    try {
      await this.$axios.$post('institutes', form)

      await dispatch('loadAll')
    } catch (error) {
      console.error(error)
    }
  },

  async updateInstitute({ dispatch }, form) {
    try {
      delete form.documents
      await this.$axios.patch(`institutes/${form.id}`, form)

      dispatch('loadAll')
    } catch (error) {
      console.error(error)
    }
  },

  async destroyInstitute({ dispatch }, id) {
    await this.$axios.delete(`institutes/${id}`)
    dispatch('loadAll')
  },

  async restoreInstitute({ dispatch }, id) {
    await this.$axios.post(`institutes/${id}/restore`)
    await dispatch('loadAll')
  },
}

export const mutations = {
  setInstitutes(state, institute) {
    state.institutes = institute
  },

  setProducts(state, products) {
    state.products = products
  },
}

export const getters = {
  institutes(state) {
    return state.institutes
  },

  activeInstitutes(state) {
    return state.institutes.filter((institute) => !institute.deleted_at)
  },

  archivedInstitutes(state) {
    return state.institutes.filter((institute) => institute.deleted_at)
  },

  products(state) {
    return state.products
  },

  instituteOptions(state) {
    return state.institutes.map((institute) => ({
      value: institute.id,
      label: `${institute.name}${institute.deleted_at ? ' (archiviert)' : ''}`,
      deleted_at: institute.deleted_at,
      consultants: institute.consultants.map((consultant) => ({
        value: consultant.id,
        label: `${consultant.first_name} ${consultant.last_name}`,
      })),
    }))
  },
}
